import { Api } from '../api/api.js';

export type FormLog = {
    id?: number,
    created?: string,
    site_url?: string,
    http_code?: number,
    http_answer?: string,
    user_agent?: string,
    framework_version?: string,
}

export class FormLogger {
    /**
     * clones the response and logs it
     */
    static async logResponse(response: Response, log = true): Promise<Response> {
        if (log === false) return response;

        console.log('logging response', response);
        await FormLogger.uploadLog(FormLogger.buildData({
            http_code: response.status,
            http_answer: await response.clone().text(),
        }));

        return response;
    }

    static async logError(reason: any, log = true): Promise<any> {
        if (Api.log === false) {
            if (reason instanceof Error) throw reason;
            return reason;
        }

        console.log('logging error', reason);
        await FormLogger.uploadLog(FormLogger.buildData({
            http_code: 0,
            http_answer: reason.toString(),
        }));
        if (reason instanceof Error) throw reason;
        return reason;
    }

    private static buildData(partial: FormLog) {
        return {
            site_url: document.URL,
            user_agent: navigator.userAgent,
            framework_version: window.version ?? null,
            ...partial,
        } as FormLog;
    }

    private static async uploadLog(data: FormLog) {
        Api.log = false;
        Api.csrf = false;

        try {
            await Api.api_put('https://api.moxi.ch/api/form_logger/api.php', data);
        } catch (error) {
            console.error(error);
        }

        Api.csrf = true;
    }
}
